// src/components/global/LanguageToggle.jsx
import React, { useEffect } from "react";
import { FormControlLabel, Switch, Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const LanguageToggle = ({
    activeLang,
    onChange,
    showLabel = true,
    size = "medium",
}) => {
    const { i18n } = useTranslation();
    const isEnglish = activeLang === "en";

    // ✅ متابعة تغييرات i18next تلقائياً
    useEffect(() => {
        const currentI18nLang = i18n.language || "en";
        const normalizedLang = currentI18nLang.startsWith("ar") ? "ar" : "en";

        // إذا تغيرت لغة i18next وكانت مختلفة عن activeLang، حدث activeLang
        if (normalizedLang !== activeLang) {
            if (onChange) onChange(normalizedLang);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n.language]); // ✅ إضافة جميع الـ dependencies

    const handleToggle = (_, checked) => {
        const newLang = checked ? "en" : "ar";
        if (onChange) onChange(newLang);
    };

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
            }}
        >
            {showLabel && (
                <Box sx={{ textAlign: "right" }}>
                    <Typography variant="caption" color="text.secondary">
                        {activeLang === "ar" ? "لغة الإدخال" : "Input language"}
                    </Typography>
                    <Typography variant="body2" fontWeight={600}>
                        {activeLang === "ar" ? "عربي" : "English"}
                    </Typography>
                </Box>
            )}

            <FormControlLabel
                sx={{
                    m: 0,
                    ".MuiFormControlLabel-label": {
                        fontSize: 13,
                    },
                }}
                control={
                    <Switch
                        checked={isEnglish}
                        onChange={handleToggle}
                        color="primary"
                        size={size}
                    />
                }
                label={
                    activeLang === "ar"
                        ? "عربي / إنجليزي"
                        : "AR / EN"
                }
                labelPlacement="start"
            />
        </Box>
    );
};

export default LanguageToggle;
